module.exports = __webpack_public_path__ + "static/media/2019_4G8A5306.dce082f6.jpg";